export default {
    ambienceTypes:          { method: 'get',    url: 'ambience_types' },
    ambienceTypesFilter:    { method: 'get',    url: 'ambience_types/filter' },
    createAmbienceType:     { method: 'post',   url: 'ambience_types'},
    updateAmbienceType:     { method: 'put',    url: 'ambience_types/{id}'},
    deleteAmbienceType:     { method: 'delete', url: 'ambience_types/{id}'}
}